import { DialogConfirmation } from '@reapitform/common-ui'
import { useDefaultsLinkDelete } from '../../../../..//api/defaults/links'
import React, { useEffect } from 'react'
import { IDefaultLink } from '../../../../../api/types'

interface ILinkDeleteConfirmationModal {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  refreshList: (data: IDefaultLink[] | ((preData: IDefaultLink[]) => IDefaultLink[])) => void
  data?: IDefaultLink
}

export const LinkDeleteConfirmationModal: React.FC<ILinkDeleteConfirmationModal> = ({
  data,
  isOpen,
  onOpenChange,
  refreshList,
}) => {
  const { isLoading, deleteLink, isSuccess } = useDefaultsLinkDelete(String(data?.id))

  const handleClose = () => onOpenChange(false)
  const handleConfirm = () => {
    deleteLink(undefined)
  }

  useEffect(() => {
    if (!isSuccess || !data?.id) return

    refreshList((prevLinkList) => prevLinkList.filter((link) => link.id !== data.id))
    handleClose()
  }, [isSuccess, data?.id])

  if (!data) return

  return (
    <DialogConfirmation
      isOpen={isOpen}
      message={`This action will permanently delete the link ${data.title} and cannot be undone.`}
      onCancel={handleClose}
      onClose={handleClose}
      confirmButtonText="Delete"
      intent="danger"
      title="Delete Link"
      onConfirm={handleConfirm}
      isLoading={isLoading}
    />
  )
}
